import FastVehicleCreation from './styled';

export default FastVehicleCreation;
